module.exports = __webpack_public_path__ + "media/images/ellipses-dots-0211cf697abafa64dee689dfe9ad598c.png";